import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";

export default function ServiceCard({ s, i }) {
  return (
    <Reveal delay={(i % 3) * 0.08} className="h-full">
      <div
        data-testid={s.testid}
        className="group flex h-full flex-col border border-line bg-coal transition-colors duration-500 hover:border-steel"
      >
        <div className="relative h-52 overflow-hidden">
          <img
            src={s.img}
            alt={s.title}
            loading="lazy"
            className="h-full w-full object-cover grayscale transition-transform duration-700 ease-out group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-coal via-coal/20 to-transparent" />
          <span className="absolute left-4 top-4 border border-line bg-ink/70 px-2 py-1 font-mono text-[11px] tracking-[0.3em] text-silver backdrop-blur-sm">
            {s.num}
          </span>
        </div>
        <div className="flex flex-1 flex-col p-6">
          <h3 className="font-display text-lg font-bold uppercase leading-snug tracking-tight">{s.title}</h3>
          <p className="mt-3 flex-1 text-sm leading-relaxed text-fog">{s.desc}</p>
          <div className="mt-6 flex items-center justify-between border-t border-line pt-4">
            <Link to={s.link} data-testid={`${s.testid}-explore`} className="link-arrow">
              Explore
            </Link>
            <Link
              to="/contact"
              data-testid={`${s.testid}-consult`}
              className="flex items-center gap-1.5 font-mono text-[11px] uppercase tracking-[0.25em] text-fog transition-colors duration-300 group-hover:text-white"
            >
              Consult <ArrowUpRight className="h-3.5 w-3.5" />
            </Link>
          </div>
        </div>
      </div>
    </Reveal>
  );
}
